import service from '@/services/mediaCenter';

let getAllTimeout;
let getZipTimeout;
export default {
  namespaced: true,
  state: {
    data: {
      content: [],
      pagination: {
        page: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    },
    params: {
      size: 15,
      page: 0,
      imageName: null,
      active: true,
    },
    count: {},
  },
  getters: {
    getFiles (state) {
      return state.data.content;
    },
    getPagination (state) {
      return state.data.pagination;
    },
    getCount (state) {
      return state.count;
    },
    getParams (state) {
      return state.params;
    },
  },
  mutations: {
    getAllFiles (state, files) {
      state.data.content = files.content;
      state.data.pagination = {
        page: files.page,
        size: files.size,
        totalElements: files.totalElements,
        totalPages: files.totalPages,
      };
    },
    pushItem (state, file) {
      state.data.content.unshift(file);
    },
    setParams (state, params) {
      state.params = { ...state.params, ...params };
    },
    setCount (state, count) {
      state.count = count;
    },
  },
  actions: {
    async removeFile ({ commit, dispatch }, fileId) {
      await service.removeImage(fileId);
    },
    async prepareUpload ({ commit }, payload) {
      const response = await service.prepareToUpload(payload.file.name);
      return response;
    },
    async getFileInfo ({ commit }, fileUrl) {
      const response = await service.getFileInfo(fileUrl);
      return response;
    },
    async uploadFile ({ commit, dispatch }, params) {
      await service.uploadToImage(params);
      clearTimeout(getAllTimeout);
      getAllTimeout = setTimeout(() => {
        dispatch('getAllFiles', {});
      }, 250);
    },
    async getAllFiles ({ commit, getters }) {
      let files;
      const params = getters.getParams;

      if (!params.imageName) {
        files = await service.getAll(params);
      } else {
        files = await service.getAllByName(params);
      }

      commit('getAllFiles', files);
    },
    pushItem ({ commit, dispatch, getters }, file) {
      commit('pushItem', file);
      clearTimeout(getZipTimeout);
      getZipTimeout = setTimeout(() => {
        dispatch('getAllFiles');
      }, 20000);
    },
    async getTabCount ({ commit }) {
      const params = { page: 0, size: 1, active: true };
      const response = await Promise.all([service.getAll(params), service.getAll({ ...params, ...{ active: false } })]);
      commit('setCount', {
        active: response[0].totalElements,
        passive: response[1].totalElements,
      });
    },
    setParams ({ commit }, params) {
      commit('setParams', params);
    },
  },
};
